
import { useLanguage } from "@/contexts/LanguageContext";
import { useCampaignSubmission } from "@/hooks/useCampaignSubmission";
import { StepWizard } from "./StepWizard";
import { AdminBypassProvider } from "@/contexts/AdminBypassContext";

interface CampaignCreatorProps {
  campaignId?: string;
  mode?: 'create' | 'draft' | 'edit';
}

export const CampaignCreator = ({ campaignId, mode = 'create' }: CampaignCreatorProps) => {
  const { t } = useLanguage();
  
  // Get campaign submission functionality
  const { 
    isSubmitting, 
    setShowTerms,
    setShowPayment,
  } = useCampaignSubmission();

  return (
    <AdminBypassProvider>
      <StepWizard 
        campaignId={campaignId}
        mode={mode}
        onSubmit={() => {
          // Go directly to payment popup (terms are handled within)
          console.log("CampaignCreator: Opening payment popup directly");
          setShowPayment(true);
        }}
        isSubmitting={isSubmitting}
      />
    </AdminBypassProvider>
  );
};
